import script from "./ChatReportItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatReportItem.vue?vue&type=script&setup=true&lang=js"

import "./ChatReportItem.vue?vue&type=style&index=0&id=3a1d97d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a1d97d4"]])

export default __exports__